import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  avatar: {
    borderRadius: '50%',
  },
})

export default function ProfilePhoto() {
  const classes = useStyles()

  return (
    <StaticImage
      src="../../images/profilepic2.png"
      placeholder="blurred"
      className={classes.avatar}
      alt="flvyu's profile photo"
      width={100}
      height={100}
    />
  )
}
